<template>
	<div class="">
		<!--头部-->
		<div class="layout m-brand">
			<div class="banner wow fadeInUp animated" data-wow-delay="0.5s">
				<img class="<strong></strong>pic" :src="zidiyiData.ppxm_banner.files" />
			</div>
			<!--福建省沈绍安漆艺博物馆 GO -->
			<div class="introduce">
				<div class="cont">
					<!--通用头部 GO-->
					<div class="commo_tit">
						<div class="tit_left">
							<div class="yipinyun-dec">
								<div class="logo">
									<img src="@/assets/img/ssaqy-logo.png" />
								</div>
							</div>
							<div class="info_tit">
								<span
									class="span">{{lang=='CN' ?'沈绍安漆艺博物馆':'Fujian Province Shenshaoan Lacquer Art Museum'}}</span>
								<el-divider direction="vertical"></el-divider>
								<span>INTRODUCE</span>
							</div>

						</div>
			<!-- 			<div class="tit_right pointer" @click="go(220)">
							<span>查看更多</span>
							<el-divider direction="vertical"></el-divider>
							<span>MORE</span>
						</div> -->
					</div>
					<!-- 品牌介绍 -->
					<div class="txts row">
						<div class="txt col-xs-12 col-lg-12">
							<div class="js_nr"
								v-html="lang=='CN' ? zidiyiDataDes.ppxm_txt.cn_content:zidiyiDataDes.ppxm_txt.en_content">
							</div>
						</div>
					</div>
				</div>
				<div class="open-time">
					<div class="msg row">
						<div class="cont-left">
							<div class="tit1">{{lang=='CN' ?'沈绍安漆艺博物馆':'Shenshaoan Lacquer Art Museum'}}</div>
							<div class="tit2">【{{lang=='CN' ?'免费开放时间':'Free Time'}}】</div>
							<div class="line"></div>
							<div class="week">{{lang=='CN' ?'星期一 至 星期日(星期一闭馆)':'Tuesday to Sunday'}}</div>
							<div class="time">09:00-17:00</div>
						</div>
						<div class="cont-center ">
							<div class="item css3" @click="go(217)">
								<div class="snake snake1 css3 snake-clumn "></div>
								<div class="snake snake2 css3 snake-row"></div>
								<div class="snake snake3 css3 snake-clumn"></div>
								<div class="snake snake4 css3 snake-row"></div>
								<div class="snake snake5 css3 snake-clumn"></div>
								<div class="snake snake6 css3 snake-row"></div>
								<div class="snake snake7 css3 snake-clumn"></div>
								<div class="snake snake8 css3 snake-row"></div>
								<div class="ico"><img src="../assets/img/ico1.png" alt="沈绍安漆艺博物馆"></div>
								<div class="tit">查看地址</div>
								<div class="txt">VIEW ADDRESS</div>
							</div>
							<div class="item css3" @click="go(218)">
								<div class="snake snake1 css3 snake-clumn "></div>
								<div class="snake snake2 css3 snake-row"></div>
								<div class="snake snake3 css3 snake-clumn"></div>
								<div class="snake snake4 css3 snake-row"></div>
								<div class="snake snake5 css3 snake-clumn"></div>
								<div class="snake snake6 css3 snake-row"></div>
								<div class="snake snake7 css3 snake-clumn"></div>
								<div class="snake snake8 css3 snake-row"></div>
								<div class="ico"><img src="../assets/img/ico2.png" alt="沈绍安漆艺博物馆"></div>
								<div class="tit">文明观展</div>
								<div class="txt">CIVILIZATION EXHIBITION</div>
							</div>
							<div class="item css3" @click="go(219)">
								<div class="snake snake1 css3 snake-clumn "></div>
								<div class="snake snake2 css3 snake-row"></div>
								<div class="snake snake3 css3 snake-clumn"></div>
								<div class="snake snake4 css3 snake-row"></div>
								<div class="snake snake5 css3 snake-clumn"></div>
								<div class="snake snake6 css3 snake-row"></div>
								<div class="snake snake7 css3 snake-clumn"></div>
								<div class="snake snake8 css3 snake-row"></div>
								<div class="ico"><img src="../assets/img/ico3.png" alt="沈绍安漆艺博物馆"></div>
								<div class="tit">开放公告</div>
								<div class="txt">OPEN ANNOUNCEMENT</div>
							</div>
						</div>
						<div class="cont_right" v-if="item.cn_name=='沈绍安漆艺'" v-for="(item,index) in companyList">
							<div class="qrcode"><img :src="item.ewm2" style="width: 210px;" /></div>
							<div class="tip">{{lang=='CN' ?'扫描二维码关注公众号':'Scan on wechat'}}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 花瓶区块 GO -->
			<div class="m-vase">
				<div class="vase"><img src="../assets/img/vase.png" alt="沈绍安漆艺博物馆"></div>
				<!-- 博物馆 GO -->
				<div class="cont">
					<div class="title" @click="go_list(85)">
						<div class="tit">{{lang=='CN' ?'沈绍安漆艺研究院':'Shenshaoan Research'}}</div>
						<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
					</div>
					<div class="items">
						<div class="item" v-for="(item,i) in archTwoList" :key="item.title"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
							<div class="txt">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
							<div class="date">{{item.publishtime_text}}</div>
						</div>
					</div>
				</div>
				<!-- 研究院 GO -->
				<div class="cont cont-push-right">
					<div class="title" @click="go_list(84)">
						<div class="tit">{{lang=='CN' ?'沈绍安漆艺博物馆':'Shenshaoan  Museum'}}</div>
						<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
					</div>
					<div class="items">
						<div class="item" v-for="(item,i) in archOneList" :key="item.title"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
							<div class="txt">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
							<div class="date">{{item.publishtime_text}}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 漆艺作品 GO -->
			<div class="m-paint-art">
				<div class="cont">
					<div class="title" @click="go_list(86)">
						<div class="tit">{{lang=='CN' ?'漆艺作品':'Lacquer works'}} </div>
						<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
					</div>
					<div class="ocupied"></div>
					<div class="swiper-container">
						<swiper :options="swiperOption" ref="mySwiper" :pagination="{clickable:true}">
							<div class="swiper-slide" v-for="(item,index) in archSixList" :key="item.title"
								 @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
								<div class="item">
									<div class="photo"> <img :src="item.image" alt=""></div>
									<div class="txt">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
									<div class="date">{{lang=='CN' ? '制作时间/年份': 'createTime/Year:'}}
										{{item.publishtime_text}}
									</div>
								</div>
							</div>
						</swiper>
						<!-- 如果需要分页器 -->
						<div class="swiper-pagination">
						</div>
						<!-- 如果需要导航按钮 -->
						<!--<div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div> -->
						<!-- 如果需要滚动条 -->
						<div class="swiper-scrollbar">
						</div>
					</div>
				</div>
			</div>
			<!-- 非遗研学 活动资讯 GO -->
			<div class="m-news">
				<div class="wrap">
					<!-- 非遗研学 GO -->
					<div class="cont">
						<div class="title" @click='go_list(87)'>
							<div class="tit">{{lang=='CN' ?'非遗研学':'Intangible cultural'}}</div>
							<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
						</div>
						<div class="items">
							<div class="item" v-for="(item,i) in archThreeList" :key="item.title"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
								<div class="txt">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
								<div class="date">{{item.publishtime_text}}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 活动资讯 GO -->
				<div class="wrap cont-push-right">
					<div class="cont" style="overflow: initial;">
						<div class="title" @click='go_list(88)'>
							<div class="tit">{{lang=='CN' ?'活动资讯':'Activity information'}}</div>
							<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
						</div>
						<div class="items">
							<div class="item" v-for="(item,i) in archFourList" :key="item.title"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
								<div class="txt">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
								<div class="date">{{item.publishtime_text}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 5个入口 GO -->
			<div class="m-icons">
				<div class="item item1 css3" @click="goPublications()">
					<div class="icons-hover css3"></div>
					<div class="ico"><img src="../assets/img/ico5.png" alt="沈绍安漆艺博物馆"></div>
					<div class="tit">刊物</div>
					<div class="txt">PULICATION</div>
				</div>
				<div class="item item2 css3" @click="go_szww()">
					<!-- <div class="item item2 css3" @click="goShop(6)"> -->
					<div class="icons-hover css3"></div>
					<div class="ico"><img src="../assets/img/ico6.png" alt="沈绍安漆艺博物馆"></div>
					<div class="tit">数字藏品</div>
					<div class="txt">DIGITAL CULTURAL RELICS</div>
				</div>
				<div class="item item3 css3" @click="go_list(106)">
					<div class="icons-hover css3"></div>
					<div class="ico"><img src="../assets/img/ico7.png" alt="沈绍安漆艺博物馆"></div>
					<div class="tit">视频</div>
					<div class="txt">VIDEO</div>
				</div>
				<div class="item item4 css3" @click="goVr()">
					<div class="icons-hover css3"></div>
					<div class="ico"><img src="../assets/img/ico8.png" alt="沈绍安漆艺博物馆"></div>
					<div class="tit">展馆全景</div>
					<div class="txt">PANORAMA</div>
				</div>
				<div class="item item5 css3" @click="go_list(104)">
					<div class="icons-hover css3"></div>
					<div class="ico"><img src="../assets/img/ico9.png" alt="沈绍安漆艺博物馆"></div>
					<div class="tit">党建</div>
					<div class="txt">PARTY BUILDING</div>
				</div>
			</div>
			

			<!-- 文创商城  GO-->
			<div class="pro-container" style="margin-bottom: 0;">
				<div class="info_tit">
					<div class="tit_left">
						<span>视频信息 </span>
						<el-divider direction="vertical"></el-divider>
						<span>Video</span>
					</div>
					<div class="tit_right" @click="go_list(106)">
						<span>查看更多</span>
						<el-divider direction="vertical"></el-divider>
						<span>MORE</span>
					</div>
				</div>
				<div class="row" v-if="archVideoList.length>0"  style="margin: 0px;">
					<div class="item  " v-for="(item,index) in archVideoList"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">

							<div class="photos">
								<img class="photo" :src="item.image" />
							</div>
							<div class="info">
								<span class="right_tit line-1" style="color: #000000; font-size:16px; line-height: 40px;">{{lang=='CN' ?item.cn_title:item.en_title}}</span>

							</div>
		
					</div>
				</div>
		
				<div class="row" v-else>
					暂无数据~
				</div>
			</div>
		
			<!-- 展馆资讯 |  real-time info GO-->
			<div class="m-newList list_info" style="margin-top: 60px;">
				<div class="info_tit">
					<div class="tit_left">
						<span>活动资讯</span>
						<el-divider direction="vertical"></el-divider>
						<span>REAL-TIME INFO</span>
					</div>
					<div class="tit_right" @click="go_list(120)">
						<span>查看更多</span>
						<el-divider direction="vertical"></el-divider>
						<span>MORE</span>
					</div>
				</div>
				<div class="liebiao_list ">
					<div class="">
						<div class="liebiao_info css3" v-for="(item,index) in archFiveList">
							<div class="info_left col-xs-12 col-lg-3">
								<div class="border-hover css3"></div>
								<img class="css3" :src="item.image" />
							</div>
							<div class="info_right col-xs-12 col-lg-9"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
								<span class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
								<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
								<div class="right_down">
									<span>{{item.publishtime_text}}</span>
									<div class="right_down_div">
										<span class="commo_span">
											<img class="eye" src="@/assets/news/eye.svg" />
											<span>{{item.view}}</span>
										</span>
										<span class="commo_span">
											<img src="@/assets/news/comment.svg" />
											<span>{{item.comment_num}}</span>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 文创商城  GO-->
			<div class="pro-container">
				<div class="info_tit">
					<div class="tit_left">
						<span>文创商城 </span>
						<el-divider direction="vertical"></el-divider>
						<span>SHOPPING MALL</span>
					</div>
					<div class="tit_right" @click="goShop(6)">
						<span>查看更多</span>
						<el-divider direction="vertical"></el-divider>
						<span>MORE</span>
					</div>
				</div>
				<div class="row" v-if="proList.length>0">
					<div class="item  " v-for="(item,index) in proList">
						<a :href="item.outlink" target="_blank">
							<div class="photos">
								<img class="photo" :src="item.image" />
								<div class="ewm css3">
									<img :src="item.ewm" />
									<div class="tips">
										{{lang=='CN' ?'扫码了解商品详情':'Find out details'}}
									</div>
								</div>
								<div class="mask css3"></div>
							</div>
							<div class="info">
								<div class="title line-2">{{lang=='CN' ? item.title: item.en_title}}</div>
								<div class="time">{{lang=='CN' ? '制作时间/年份': 'createTime/Year:'}}
									{{item.createtime_text}}
								</div>
							</div>
						</a>
					</div>
				</div>
				<div class="row" v-else>
					暂无数据~
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		WOW
	} from 'wowjs'


	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper"
	import 'swiper/css/swiper.css'

	export default {
		components: {

			swiper,
			swiperSlide
		},
		name: 'brand_project',
		data() {
			return {
				parent_id: 11,

				mySwiper: '',
				per_page: 5,
				page: 1,
				archOneList: [], //84 博物馆
				archTwoList: [], //85 研究院
				archThreeList: [], //87 非遗研学
				archFourList: [], //888  活动资讯 调用公众号117 知识文章 2022-8-31 11:43:15 换活动资讯
				archFiveList: [], //86 漆艺作品
				archSixList: [], //
				archVideoList: [], //
				
				proList: [], //产品
				content: {}, //内容详情
				total: '',
				dataListMindex: 0,
				screenWidth: document.body.clientWidth || 1920, // 屏幕尺寸
				company_id: 1, //公司ID
				companyList: [], //公司列表
				zidiyiData: {
					ppxm_banner: {
						files: ''
					}
				},
				zidiyiDataDes: {
					ppxm_txt: {
						cn_content: '',
						en_content: ''
					}
				},
				lang: localStorage.getItem('lang') || 'CN',
				swiperOption: {
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 4,
					// 显示分页
					pagination: {
						el: ".swiper-pagination",
						clickable: true //允许分页点击跳转
					},
					// 设置点击箭头
					// navigation: {
					//   nextEl: ".swiper-button-next",
					//   prevEl: ".swiper-button-prev"
					// }
				}
			}
		},


		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			}
		},

		created() {
			this.getAllNewsList()
			this.getCompanyList()
			this.getZidiyiData()
			this.getZidiyiDataDes()
			this.getProductList(5)

			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},

		mounted() {
			this.parent_id = this.$route.query.parent_id
			let data = {
				parent_id: this.parent_id
			}
		},
		methods: {

			getAllNewsList() {
				let temp = [],
					data = {
						channel_id: '84,85,87,88,120,86,106',
						per_page: '5,5,5,5,5,5,8,8'
					}
				this.$axios.get("/api/jx/archives_list_new", {
					params: data
				}).then((res) => {

					temp = res.data.data
					this.archOneList = temp[0] ? temp[0].data : temp
					this.archTwoList = temp[1] ? temp[1].data : temp
					this.archThreeList = temp[2] ? temp[2].data : temp
					this.archFourList = temp[3] ? temp[3].data : temp
					this.archFiveList = temp[4] ? temp[4].data : temp
					this.archSixList = temp[5] ? temp[5].data : temp
					this.archVideoList = temp[6] ? temp[6].data : temp
					

					this.archFiveList.map(item => {
						item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
							.en_content)
						item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
							.cn_content)

					})

				}).catch(err => {});
			},
			
			goVr() {
				window.open('https://business.25pai.com/panoview/317181451567104?scene_id=22211',"_blank")

			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},
			toggleNext(index) {
				this.curr = index
				this.newCurr = index

				this.jx_index = this.list[index].children[0].id
				if (this.list[index].children[0].id == 6757) {
					this.neirongjieshao()
					return
				}
				this.detail(this.list[this.newCurr].children[0].id)
				this.getArchivesList(this.list[this.newCurr].children[0].id)
			},

			//跳转更多
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},
			go_szww() {
				this.$router.push({
					path: `digital_cultural_legacy`
				})
			},
			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},

			go_dqgy(id) {

				this.$router.push({
					path: `dqgy?parent_id=12`,
				})

			},
			goDetail(id) {
				let data = {
					id: id
				}


				this.$axios.get("/api/jx/archives_detail", {
					params: data
				}).then((res) => {

					if (res.data.code == 1) {
						if (res.data.data.outlink != '' || res.data.data.outlink != '#') {
							window.open(res.data.data.outlink, '_self')
						} else {

							this.$router.push({
								path: `new_detail?id=${id}`
							})


						}
					}
				}).catch(err => {});
			},


			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},

			goPublications(id) {
				this.$router.push({
					path: `Publication_list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},

			getProductList(id) {
				let data = {
					company_id: id,
					per_page: 8,
					page: 1
				}
				this.$axios.get("/api/jx/product_list", {
					params: data
				}).then((res) => {
					if (res.data.code == 1) {
						this.proList = res.data.data.data
						this.total = res.data.data.total
					}
				}).catch(err => {});
			},

			goShop(id) {
				this.$router.push({
					path: `shop`,
					query: {
						id: id
					}
				})
			},

			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}


				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {
					this.zidiyiData = res.data.data

				}).catch(err => {});
			},
			// 获取自定义富文本
			getZidiyiDataDes() {
				let data = {
					keys: 'ppxm_txt,gywm'
				}
				this.$axios.get("/api/jx/get_content", {
					params: data
				}).then((res) => {

					this.zidiyiDataDes = res.data.data

				}).catch(err => {});
			},
			//获取侧边公司列表
			getCompanyList() {
				let data = {}

				this.$axios.get("/api/jx/cb_company", {
					params: data
				}).then((res) => {
					this.companyList = res.data.data
				}).catch(err => {})
			},
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},

		}
	}
</script>
<style lang="scss" scoped>
	a:hover,
	a:focus {
		text-decoration: none !important;
	}

	.m-brand .col-lg-5 {
		padding-left: 0 !important;
	}

	.m-brand .col-lg-7 {
		padding-right: 0 !important;
	}

	.m-brand .col-lg-2 {
		padding-left: 0 !important;
	}

	.m-brand .col-lg-10 {
		padding: 0 !important;
	}

	.m-brand .col-lg-4 {
		padding: 20px !important;
	}

	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.m-brand {
		background: #fff;

		.banner {
			padding: 0px 0px 30px;

			.pic {
				width: 100%;
			}
		}

		.introduce {
			max-width: 1860px;
			margin: 0 auto 0px;
			position: relative;
			overflow: hidden;
			background: url(../assets/img/yipinyun_bg.jpg) 0 0 no-repeat;

			.cont {
				max-width: 1400px;
				margin: 100px auto 0;
				height: auto !important;
				position: relative;
			}

			.txts {
				margin: 10px 0 30px;
				font-size: 18px;
			}

			.txt {
				padding: 0;
				margin-top: 15px;
				height: 320px;
				overflow: hidden;

			}

			.open-time {
				width: calc(100% - 60px);
				height: 400px;
				margin: 0 auto;
				overflow: hidden;
				background: url(../assets/img/opentime_bg.jpg);

				.msg {
					margin: 70px 100px;
					overflow: hidden;
				}

				.cont-left {
					width: 350px;
					float: left;

				}

				.tit1 {
					font-size: 30px;
					color: #ffffff;
					letter-spacing: 3px;
				}

				.tit2 {
					font-size: 24px;
					color: #ffffff;
					letter-spacing: 3px;
					margin-top: 20px;
					position: relative;
					left: -4px;
				}

				.line {
					width: calc(100% - 80px);
					height: 1px;
					background: #9b5051;
					margin-top: 25px;
				}

				.week {
					font-size: 22px;
					color: #ffffff;
					letter-spacing: 3px;
					margin-top: 25px;
				}

				.time {
					font-size: 54px;
					color: #d4b467;
					margin-top: 10px;
				}

			}
		}


	}


	.cont-center {
		// width: 940px;
		height: 245px;
		text-align: center;
		float: left;

		.item {
			width: 244px;
			height: 244px;
			margin-left: 30px;
			border: 1px solid #9b5051;
			display: inline-block;
			cursor: pointer;
			position: relative;
			overflow: hidden;
			background: url(../assets/img/active.png) center no-repeat;
			background-size: 0 0;

			.snake {
				position: absolute;
				background: #d4b467;
			}

			.snake-clumn {
				width: 2px;
				height: 66px;
			}

			.snake-row {
				width: 66px;
				height: 2px;
			}

			.snake1 {
				top: -100%;
				left: 0px;
			}

			.snake2 {
				top: 0px;
				left: -100%;
			}

			.snake3 {
				top: -100%;
				right: 0px;
			}

			.snake4 {
				top: 0px;
				right: -100%;
			}

			.snake5 {
				bottom: -100%;
				right: 0px;
			}

			.snake6 {
				bottom: 0px;
				right: -100%;
			}

			.snake7 {
				bottom: -100%;
				left: 0px;
			}

			.snake8 {
				bottom: 0px;
				left: -100%;
			}
		}

		.item:hover {
			background-size: 100% 100%;
		}

		.item:hover .snake1 {
			top: 0px;
		}

		.item:hover .snake2 {
			left: 0px;
		}

		.item:hover .snake3 {
			top: 0px;
		}

		.item:hover .snake4 {
			right: 0px;
		}

		.item:hover .snake5 {
			bottom: 0px;
		}

		.item:hover .snake6 {
			right: 0px;
		}

		.item:hover .snake7 {
			bottom: 0px;
		}

		.item:hover .snake8 {
			left: 0px;
		}

	}

	.cont-center .ico {
		margin: 18px auto 0;
	}

	.cont-center .ico,
	.cont-center .ico img {
		width: 120px;
		height: 120px;
	}

	.cont-center .item .tit {
		font-size: 20px;
		color: #ffffff;
		margin-top: 25px;
	}

	.cont-center .item .txt {
		font-size: 14px;
		color: #ffffff;
		margin-top: 10px;
		opacity: .4;
	}

	.cont_right {
		width: 250px;
		height: 270px;
		float: right;
		margin-right: 30px;
		text-align: center;
	}

	.cont_right .qrcode {
		margin: 0 auto;
	}

	.cont_right .qrcode img {
		margin: 0 auto;
	}

	.cont_right .tip {
		color: #ffffff;
		text-align: center;
		margin-top: 20px;
		font-size: 18px;
	}


	/*花瓶区块 GO*/
	.m-vase {
		max-width: 1860px;
		margin: 0 auto 0px;
		height: 560px;
		background: url(../assets/img/vase.jpg) center no-repeat;
		margin: 40px auto 0;
		position: relative;

		.cont {
			width: 520px;
			height: 470px;
			float: left;
			margin: 50px 0 0 100px;
		}

		.cont-push-right {
			float: right;
			margin-right: 100px;
		}

		.title {
			font-size: 30px;
			color: #000000;

			.tit {
				font-size: 30px;
				color: #000000;
				float: left;
				position: relative;
			}

			.tit::before {
				width: 16px;
				height: 36px;
				overflow: hidden;
				background: url(../assets/img/tit-bg.png) 0 0 no-repeat;
				display: block;
				position: absolute;
				top: 3px;
				left: -30px;
				content: '';
			}

			.tit::after {
				width: 16px;
				height: 36px;
				overflow: hidden;
				background: url(../assets/img/tit-bg.png) -16px 0 no-repeat;
				display: block;
				position: absolute;
				top: 3px;
				right: -30px;
				content: '';
			}

			.more {
				width: 80px;
				height: 35px;
				line-height: 35px;
				color: #000000;
				font-size: 16px;
				border: 1px solid #796638;
				text-align: center;
				float: right;
				cursor: pointer;
			}

			.more:hover {
				color: #ffffff;
				background: #831c1f;
			}

		}

		.items {
			width: 520px;
			height: 400px;
			overflow: hidden;
			float: left;
			overflow: hidden;

			.item {
				width: 520px;
				height: 80px;
				line-height: 80px;
				overflow: hidden;
				border-bottom: 1px solid #826e40;
				cursor: pointer;

				.txt {
					width: 388px;
					height: 80px;
					line-height: 80px;
					font-size: 18px;
					color: #1a1a1a;
					float: left;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.date {
					width: 120px;
					height: 80px;
					line-height: 80px;
					font-size: 14px;
					color: #1a1a1a;
					overflow: hidden;
					float: right;
					text-align: right;
				}

			}

			.item:hover .txt {
				color: #831c1f;
			}

			.item:hover .date {
				color: #831c1f;
			}
		}

		.vase {
			width: 248px;
			height: 555px;
			position: absolute;
			left: 50%;
			top: -80px;
			margin-left: -124px;
		}


	}


	.m-paint-art {
		max-width: 1860px;
		margin: 0 auto 0px;
		height: 736px;
		background: url(../assets/img/qiyi_bg.jpg) center no-repeat;
		margin: 50px auto 0;
		position: relative;
		overflow: hidden;
		.ocupied {
			width: 100%;
			height: 1px;
		}

		.swiper-container {
			width: 1600px;
			height: 580px;
			margin: 40px auto 0;

		}

		.swiper-slide {
			cursor: pointer;
		}

		.title {
			font-size: 30px;
			color: #000000;
			margin-top: 60px;

			.more {
				width: 80px;
				height: 35px;
				line-height: 35px;
				color: #000000;
				font-size: 16px;
				border: 1px solid #796638;
				text-align: center;
				float: right;
				cursor: pointer;
			}

			.tit {
				font-size: 30px;
				color: #000000;
				float: left;
				position: relative;
			}

			.tit::before {
				width: 16px;
				height: 36px;
				overflow: hidden;
				background: url(../assets/img/tit-bg.png) 0 -36px no-repeat;
				display: block;
				position: absolute;
				top: 3px;
				left: -30px;
				content: '';
			}

			.tit::after {
				width: 16px;
				height: 36px;
				overflow: hidden;
				background: url(../assets/img/tit-bg.png) -16px -36px no-repeat;
				display: block;
				position: absolute;
				top: 3px;
				right: -30px;
				content: '';
			}

			.more:hover {
				color: #ffffff;
				background: #831c1f;
			}

		}

		.cont {
			width: 1600px;
			height: 610px;
			margin: 60px auto;
		}

		.swiper-slide {
			width: 405px !important;
			overflow: hidden;
			position: relative;
			margin-bottom: 10px;
			float: left;
		}

		.item {
			width: 405px;
			overflow: hidden;
			position: relative;
			margin-bottom: 10px;

		}

		.photo {
			width: 380px;
			height: 380px;
			overflow: hidden;
			object-fit: cover;

			img {
				width: 380px;
				height: 380px;
				overflow: hidden;
				object-fit: cover;
			}
		}

		.txt {
			width: 380px;
			margin-top: 25px;
			height: 30px;
			line-height: 30px;
			color: #333333;
			font-size: 18px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
		}

		.txt:hover {
			color: #006170;
			cursor: pointer;
		}

		.date {
			margin-top: 10px;
			color: #666666;
			font-size: 14px;
		}

		.date:hover {
			color: #666666;
		}

	}

	/deep/ .swiper-pagination {
		bottom: 60px;
		position: relative;
	}

	/deep/ .swiper-pagination-bullet {
		width: 80px;
		height: 4px;
		background: #bfbfbf;
		margin-left: 10px;
		border-radius: 0;
	}

	/deep/ .swiper-pagination-bullet-active {
		background: #8d2629;
	}


	/*非遗研学 活动资讯 GO*/
	.m-news {
		max-width: 1800px;
		margin: 40px auto 0px;
		position: relative;
		overflow: hidden;
	}


	.m-news .wrap {
		width: 880px;
		height: 540px;
		float: left;
		background: url(../assets/img/cont-bg-1.jpg) center no-repeat;
		overflow: hidden;
	}

	.m-news .cont {
		width: 730px;
		height: 445px;
		float: left;
		margin: 60px 0 0 100px;
	}

	.m-news .cont-push-right {
		float: right;
	}

	.m-news .title {
		font-size: 30px;
		color: #ffffff;
	}

	.m-news .title .tit {
		font-size: 30px;
		color: #ffffff;
		float: left;
		position: relative;
	}

	.m-news .title .tit::before {
		width: 16px;
		height: 36px;
		overflow: hidden;
		background: url(../assets/img/tit-bg.png) 0 0 no-repeat;
		display: block;
		position: absolute;
		top: 3px;
		left: -30px;
		content: '';
	}

	.m-news .title .tit::after {
		width: 16px;
		height: 36px;
		overflow: hidden;
		background: url(../assets/img/tit-bg.png) -16px 0 no-repeat;
		display: block;
		position: absolute;
		top: 3px;
		right: -30px;
		content: '';
	}

	.m-news .title .more {
		width: 80px;
		height: 35px;
		line-height: 35px;
		color: #d4b467;
		font-size: 16px;
		border: 1px solid #a96446;
		text-align: center;
		float: right;
		cursor: pointer;
	}

	.m-news .title .more:hover {
		color: #ffffff;
		background: #831c1f;
	}

	.m-news .items {
		width: 720px;
		height: 400px;
		overflow: hidden;
		clear: both;
	}

	.m-news .item {
		width: 720px;
		height: 80px;
		line-height: 80px;
		overflow: hidden;
		border-bottom: 1px solid #b88081;
		cursor: pointer;
	}

	.m-news .item:hover .txt {
		color: #d4b467;
	}

	.m-news .item:hover .date {
		color: #d4b467;
	}

	.m-news .item .txt {
		width: calc(100% - 140px);
		height: 80px;
		line-height: 80px;
		font-size: 18px;
		color: #ffffff;
		float: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.m-news .item .date {
		width: 120px;
		height: 80px;
		line-height: 80px;
		font-size: 14px;
		color: #ffffff;
		overflow: hidden;
		float: right;
		text-align: right;
	}



	/*5个图标入口 GO*/
	.m-icons {
		max-width: 1800px;
		margin: 70px auto 0;
		overflow: hidden;
	}

	.m-icons .item {

		width: 350px;
		height: 350px;
		margin-left: 12px;
		float: left;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		text-align: center;
		background: url(../assets/img/icons.png) 0 0 no-repeat;
		background-size: 0 0;
	}

	.m-icons .item1 {
		background: url(../assets/img/icons-bg.png) 0 0 no-repeat;
		margin-left: 0px;
	}

	.m-icons .item2 {
		background: url(../assets/img/icons-bg.png) 0 -350px no-repeat;
	}

	.m-icons .item3 {
		background: url(../assets/img/icons-bg.png) 0 -700px no-repeat;
	}

	.m-icons .item4 {
		background: url(../assets/img/icons-bg.png) 0 -1050px no-repeat;
	}

	.m-icons .item5 {
		background: url(../assets/img/icons-bg.png) 0 -1400px no-repeat;
	}

	.m-icons .icons-hover {
		background: url(../assets/img/icons-hover.png) 0 0px no-repeat;
		background-size: 100% 100%;

	}

	.m-icons .icons-hover {
		width: 100%;
		height: 350px;
		position: absolute;
		top: 0px;
		left: 0px;
		z-index: 1;
		opacity: 0;
	}

	.m-icons .item:hover .icons-hover {
		opacity: 1;
	}

	.m-icons .ico {
		margin: 60px auto 0;
	}

	.m-icons .ico,
	.m-icons .tit,
	.m-icons .txt {
		position: relative;
		z-index: 2;
	}

	.m-icons .ico,
	.m-icons .ico img {
		width: 120px;
		height: 120px;
	}

	.m-icons .item .tit {
		font-size: 30px;
		color: #ffffff;
		margin-top: 50px;
	}

	.m-icons .item .txt {
		font-size: 16px;
		color: #ffffff;
		margin-top: 10px;
		opacity: .4;
	}


	/**展馆 GO*/
	.m-newList {
		width: 1400px;
		margin: 90px auto 0;

	}

	.m-newList .info_tit {
		margin-bottom: 25px;
	}

	.m-newList .liebiao_list {
		margin-top: 3px;
	}

	.m-newList .liebiao_info {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		position: relative;
		padding: 30px;
		cursor: pointer;
		width: calc(100% + 60px);
		position: relative;
		left: -30px;
	}

	.m-newList .liebiao_info:hover {
		background: #f0f4f5;
	}

	.m-newList .liebiao_info::after {
		content: '';
		width: calc(100% - 60px);
		background: #f0f4f5;
		display: block;
		height: 1px;
		position: absolute;
		bottom: 0px;
		left: 30px;
	}


	.m-newList .liebiao_info:last-child::after {
		display: none;
	}


	/**通用标题 */
	.info_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
		cursor: pointer;
	}

	.info_tit .active {
		border: 2px solid #006170;
		box-shadow: 5px 7px 10px #cddadc;
		color: #000;
	}

	.info_tit .tit_left span:first-child {
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.info_tit .tit_left span:last-child {
		font-size: 14px;
		color: #999;
	}


	.m-newList .info_left {
		margin-right: 30px;
		overflow: hidden;
		position: relative;
		z-index: 5;
	}

	.m-newList .info_left img {
		width: 100%;
		height: 200px;
	}

	.m-newList .info_left img:hover {
		transform: scale(1.2)
	}

	.m-newList .info_right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		z-index: 5;
	}

	.m-newList .right_down {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #999;
	}

	.m-newList .commo_span {
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.m-newList .commo_span img {
		width: 20px;
		margin-right: 5px;
	}

	.m-newList .right_down_div {
		display: flex;
		align-items: center;
	}

	.m-newList .right_tit {
		font-size: 24px;
		color: #000;
	}

	.m-newList .right_tit:hover {
		color: #006170;
	}

	.m-newList .jieshao {
		font-size: 14px;
		color: #666666;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;

	}

	.m-newList .jieshao:hover {
		opacity: 0.8;
	}

	.m-newList .info_tit .tit_right {
		font-size: 16px;
	}


	.m-newList .info_tit:hover .tit_right {
		color: #006170;
	}



	/* 商城 GO*/
	.pro-container {
		width: 1400px;
		margin: 90px auto 150px;
		.row{
			margin: 0;
		}
	}

	.pro-container .info_tit {
		margin-bottom: 37px;
	}

	.pro-container .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}


	.pro-container .item {
		width: 320px;
		overflow: hidden;
		position: relative;
		margin-bottom: 10px;
		float: left;
		margin: 0 0 30px 40px;
	}

	.pro-container .item:nth-child(4n+1) {
		margin-left: 0px;
	}

	.pro-container .item .photos {
		width: 100%;
		height: 320px;
		position: relative;
		overflow: hidden;
	}

	.pro-container .item .photo {
		width: 100%;
		height: 320px;
		object-fit: cover;

	}

	.pro-container .title {
		margin-top: 25px;
		height: 60px;
		line-height: 30px;
		color: #333333;
		font-size: 18px;
	}

	.pro-container .title:hover {
		color: #006170;
		cursor: pointer;
	}

	.pro-container a {
		display: block;

	}

	.pro-container .time {
		margin-top: 10px;
		color: #666666;
		font-size: 14px;
	}


	.pro-container .time:hover {
		color: #666666;
	}

	.pro-container .mask {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		opacity: 0;
		background: rgba(0, 0, 0, .5);
	}

	.pro-container .mask {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		opacity: 0;
		background: rgba(0, 0, 0, .5);
	}

	.pro-container:hover .item:hover .mask {
		opacity: 1;
	}

	.pro-container .item .ewm {
		width: 200px;
		height: 200px;
		position: absolute;
		top: 40px;
		left: 50%;
		z-index: 3;
		margin: 0px 0 0 -100px;
		transform: scale(0);
		-webkit-transform: scale(0);
		-moz-transform: scale(0);
		-o-transform: scale(0);
		-ms-transform: scale(0);
	}

	.pro-container .item .ewm img {
		width: 200px;
		height: 200px;
		object-fit: cover;
	}

	.pro-container .item:hover .ewm {

		transform: scale(1);
		-webkit-transform: scale(1);
		-moz-transform: scale(1);
		-o-transform: scale(1);
		-ms-transform: scale(1);

	}

	.pro-container .item .tips {
		width: 100%;
		line-height: 60px;
		font-size: 18px;
		color: #ffffff;
		text-align: center;
	}

	/* 通用头部 GO*/
	.commo_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		.tit_left {
			display: flex;

			.yipinyun-dec {
				position: relative;
				left: -50px;

				.logo {
					.img {
						width: 120px;
						height: 50px;
						float: left;
					}
				}
			}

			.info_tit {
				// margin-left: 40px;
				position: relative;
				left: -80px;

				.span {
					font-size: 30px;
					color: #000;
					font-weight: bold;
				}
			}
		}
	}

	.m-brand .yjy {
		margin-top: 70px;
	}

	.commo_tit .tit_left span:first-child {
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.commo_tit .el-divider--vertical {
		margin: 0 8px !important;
	}

	.commo_tit .el-divider {
		background-color: #000;
	}

	.commo_tit .tit_right {
		display: flex;
		align-items: center;
		color: #000;
	}

	@media screen and (min-width:1661px) and (max-width: 1900px) {
		.m-brand .introduce .open-time .msg {
			margin: 70px 50px;
		}

		.m-paint-art .swiper-container {
			width: 1400px;
			margin: 0 auto;
		}

		.m-paint-art .cont {
			padding: 0 50px;
		}

		.m-news {
			width: calc(100% - 60px);
		}

		.m-news .wrap {
			width: calc(100%/2 - 15px)
		}

		.m-news .cont {
			width: initial;
		}

		.cont_right {
			margin-right: 10px;
		}

		.m-news .item,
		.m-news .items {
			width: 100%;
		}

		.m-icons {
			width: 100%;
		}

		.m-icons .item {
			width: calc(100%/5 - 10px)
		}
	}

	@media screen and (min-width:1660px) and (max-width: 1700px) {
		.cont-center .item {
			width: 210px;
		}

	}

	@media screen and (min-width:1400px) and (max-width: 1660px) {
		.m-brand .introduce .open-time .msg {
			margin: 70px 50px;
		}

		.m-paint-art .swiper-container {
			width: 1400px;
			margin: 0 auto;
		}

		.m-paint-art .cont {
			padding: 0 50px;
		}

		.m-news {
			width: calc(100% - 60px);
		}

		.m-news .wrap {
			width: calc(100%/2 - 15px)
		}

		.m-news .cont {
			width: initial;
		}

		.cont-center {
			width: initial;
		}

		.cont-center .item {
			width: 210px;
		}

		.m-news .item,
		.m-news .items {
			width: 100%;
		}

		.m-icons {
			width: 100%;
		}

		.m-icons .item {
			width: calc(100%/5 - 10px)
		}
	}


	@media screen and (min-width:1500px) and (max-width: 1590px) {

		.m-brand .introduce .open-time .msg {
			margin: 70px 50px;
		}

		.m-paint-art .swiper-container {
			width: 1400px;
			margin: 0 auto;
		}

		.m-paint-art .cont {
			padding: 0 50px;
		}

		.m-news {
			width: calc(100% - 60px);
		}

		.m-news .wrap {
			width: calc(100%/2 - 15px)
		}

		.m-news .cont {
			width: initial;
		}

		.cont-center {
			width: initial;
		}

		.cont-center .item {
			width: 180px;
		}

		.m-news .item,
		.m-news .items {
			width: 100%;
		}

		.m-icons {
			width: 100%;
		}

		.m-icons .item {
			width: calc(100%/5 - 10px)
		}
	}

	@media screen and (min-width:1200px) and (max-width: 1499px) {

		.m-brand .introduce .open-time .msg {
			margin: 70px 0 70px 50px;
		}

		.m-paint-art .swiper-container {
			width: 1400px;
			margin: 0 auto;
		}

		.m-paint-art .cont {
			padding: 0 50px;
		}

		.m-news {
			width: calc(100% - 60px);
		}

		.m-news .wrap {
			width: calc(100%/2 - 15px)
		}

		.m-news .cont {
			width: initial;
		}

		.cont-center {
			width: initial;
		}

		.cont-center .item {
			width: 160px;
		}

		.m-news .item,
		.m-news .items {
			width: 100%;
		}

		.m-icons {
			width: 100%;
		}

		.m-icons .item {
			width: calc(100%/5 - 10px)
		}

		.qrcode img {
			width: 180px !important;
		}

		.cont_right {
			width: auto;
		}

	}
	
	/*影视作品*/
	
	.m-films {
		width: 1400px;
		margin: 70px auto ;
		.nav_list {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}
	
		.list {
			padding: 15px;
		}
	
		.list:hover {
			background: #E6E6E6;
		}
	
		.title {
			line-height: 30px;
			color: #1A1A1A;
			margin-top: 20px;
			font-size: 24px;
		}
	
		.detail {
			display: flex;
			justify-content: space-between;
			align-items: center;
	
			.brand {
				width: 120px;
				height: 30px;
			}
	
		}
	}
</style>
